import './App.scss';
import React, { useState } from 'react';

import MainPage from './components/Main/MainPage';
import CssBaseline from '@mui/material/CssBaseline';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';
import { getDesignTokens } from './theme';
import { CountryProvider } from './Contexts/CountryContext';
import { UserSelectionProvider } from './Contexts/UserSelectionContext';
import { LanguageProvider } from './components/Language/LanguageContext';
import { useAuth } from './Contexts/AuthContext';
import LoginPage from './components/LandingPage/LandingPage.component';

function App() {
  const [mode, setMode] = useState<PaletteMode>('dark');
  const { isAuthenticated } = useAuth(); // Use isAuthenticated from AuthContext

  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={DateAdapter}>
        <LanguageProvider>
          <UserSelectionProvider>
            <CountryProvider>
              <CssBaseline />
              {/* Render LoginPage or MainPage based on isAuthenticated */}
              {isAuthenticated ? (
                <MainPage />
              ) : (
                <LoginPage />
              )}
            </CountryProvider>
          </UserSelectionProvider>
        </LanguageProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;